/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon16Regular = forwardRef('MediaAudioWaveIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.1 2.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0V2.25Z" }),
        React.createElement("path", { d: "M13 4a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0V4Z" }),
        React.createElement("path", { d: "M16 6.5a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z" }),
        React.createElement("path", { d: "M9.25 5.25A.75.75 0 0 1 10 6v4a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M3.4 4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 3.4 4Z" }),
        React.createElement("path", { d: "M1.5 7A.75.75 0 0 0 0 7v2a.75.75 0 0 0 1.5 0V7Z" })));
});
